export default {
    getOssKey: {
        name: '获取oss上传token',
        method: 'GET',
        url: '/manage-system/common/ossToken'
    },
    ossUpload: {
        name: 'OSS上传文件',
        method: 'POST',
        url: 'https://apailang.oss-cn-hangzhou.aliyuncs.com'
    },
    downloadImage: {
        name: '图片资源下载',
        method: 'GET',
        url: '/manage-system/common/downloadImage'
    },
    staffAlert: {
        name: '重要提醒！',
        method: 'GET',
        url: '/manage-system/staff/alert'
    }
}